import { BrgButton, ButtonVariant, FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { IconCloseMob } from "../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal";
import {LayoutConst, useModal} from "../../../core";
import { useGetProject } from "shared/hooks/api/useGetProject";
import { RectangularButtonFilled } from "shared/components/buttons";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";

const Wrapper = styled(FlexBox)`
    width: 560px;
    height: 216px;
    background: #FEFEFE;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    position: relative;
    padding: 32px 40px 40px 40px;
    flex-flow: column;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px;
    width: 300px;
    height: 142px;
  }
`;

const Title = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 34px;
    letter-spacing: -0.02em;
    color: #151514;
  
    @media (max-width: ${LayoutConst.screen.s}px) {
      font-weight: 600;
      font-size: 17px;
      line-height: 22px;
      letter-spacing: normal;
    }
`;

const Text = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #909090;
    padding-top: 8px;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    padding-top: 12px;
    letter-spacing: normal;
  }
`;

const Copy = styled(FlexBox)`
    flex-flow: row;
    justify-content: center;
    padding-top: 32px;
    width: 100%;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding-top: 12px;
  }
`;
export const LegalsCloseWrapper = styled.div`
    position: absolute;
    top: 32px;
    right: 32px;
    cursor: pointer;

   @media (max-width: ${LayoutConst.screen.m}px) {
    top: 32px;
    right: 32px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    top: -35px;
    right: 0px;
    svg {
      width: 18px;
      height: 18px;
      path {
        fill: #FEFEFE;
      }
    }
  }
`;
export const SubmitButton = styled(BrgButton)`
  width: 100%;
  font-weight: 600;
  
`

export enum AccessModalTypes {
    LMS = 'lms'
}

export const AccessModal: FC<{ type?: AccessModalTypes, projectId?: string }> = ({ type = AccessModalTypes.LMS, projectId = '' }) => {
    const { t } = useTranslation();
    const modal = useModal();
    const history = useHistory();
    

    const ConfigList: Record<AccessModalTypes, any> = useMemo(() => ({
        [AccessModalTypes.LMS]: {
            title: 'Поздравляем!',
            desc: 'Теперь вам открыт доступ',
            buttonText: 'Перейти к материалам',
            onButtonClick: () => {
               history.push(CreateLinkTo.project(projectId))
               modal.hide();
            },
        },
    }), [t, modal])

    return (
            <Wrapper>
                <LegalsCloseWrapper><IconCloseMob onClick={() => modal.hide()}/></LegalsCloseWrapper>
                <Title>{ConfigList[type]?.title}</Title>
                <Text>
                    <FlexBox>
                        {ConfigList[type]?.desc}
                    </FlexBox>
                </Text>
                <Copy>
                    <SubmitButton variant={ButtonVariant.Filled} onClick={ConfigList[type]?.onButtonClick}>
                        {ConfigList[type]?.buttonText}
                    </SubmitButton>
                </Copy>
            </Wrapper>
    )
}import { BrgButton, ButtonVariant, FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { IconCloseMob } from "../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal";
import {LayoutConst, useModal} from "../../../core";
import { useGetProject } from "shared/hooks/api/useGetProject";
import { RectangularButtonFilled } from "shared/components/buttons";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";

const Wrapper = styled(FlexBox)`
    width: 560px;
    height: 216px;
    background: #FEFEFE;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    position: relative;
    padding: 32px 40px 40px 40px;
    flex-flow: column;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px;
    width: 300px;
    height: 142px;
  }
`;

const Title = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 34px;
    letter-spacing: -0.02em;
    color: #151514;
  
    @media (max-width: ${LayoutConst.screen.s}px) {
      font-weight: 600;
      font-size: 17px;
      line-height: 22px;
      letter-spacing: normal;
    }
`;

const Text = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #909090;
    padding-top: 8px;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    padding-top: 12px;
    letter-spacing: normal;
  }
`;

const Copy = styled(FlexBox)`
    flex-flow: row;
    justify-content: center;
    padding-top: 32px;
    width: 100%;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding-top: 12px;
  }
`;
export const LegalsCloseWrapper = styled.div`
    position: absolute;
    top: 32px;
    right: 32px;
    cursor: pointer;

   @media (max-width: ${LayoutConst.screen.m}px) {
    top: 32px;
    right: 32px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    top: -35px;
    right: 0px;
    svg {
      width: 18px;
      height: 18px;
      path {
        fill: #FEFEFE;
      }
    }
  }
`;
export const SubmitButton = styled(BrgButton)`
  width: 100%;
  font-weight: 600;
  
`

export enum AccessModalTypes {
    LMS = 'lms'
}

export const AccessModal: FC<{ type?: AccessModalTypes, projectId?: string }> = ({ type = AccessModalTypes.LMS, projectId = '' }) => {
    const { t } = useTranslation();
    const modal = useModal();
    const history = useHistory();
    

    const ConfigList: Record<AccessModalTypes, any> = useMemo(() => ({
        [AccessModalTypes.LMS]: {
            title: 'Поздравляем!',
            desc: 'Теперь вам открыт доступ',
            buttonText: 'Перейти к материалам',
            onButtonClick: () => {
               history.push(CreateLinkTo.project(projectId))
               modal.hide();
            },
        },
    }), [t, modal])

    return (
            <Wrapper>
                <LegalsCloseWrapper><IconCloseMob onClick={() => modal.hide()}/></LegalsCloseWrapper>
                <Title>{ConfigList[type]?.title}</Title>
                <Text>
                    <FlexBox>
                        {ConfigList[type]?.desc}
                    </FlexBox>
                </Text>
                <Copy>
                    <SubmitButton variant={ButtonVariant.Filled} onClick={ConfigList[type]?.onButtonClick}>
                        {ConfigList[type]?.buttonText}
                    </SubmitButton>
                </Copy>
            </Wrapper>
    )
}